import * as React from 'react';

function SvgAnalyticsOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.488, d: "M16.5 12.5L19 10m-7.5 1l1.5 1.5m-8.5 2L8 11M20.927 9.887a1.816 1.816 0 100-3.631 1.816 1.816 0 000 3.631zM14.857 15.958a1.816 1.816 0 100-3.63 1.816 1.816 0 000 3.63zM9.857 10.958a1.816 1.816 0 100-3.631 1.816 1.816 0 000 3.63zM3.071 17.744a1.816 1.816 0 100-3.631 1.816 1.816 0 000 3.631z" })));
}

export default SvgAnalyticsOutline;
